/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function EModuleInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="contact"
              title="e-Module Details for Pre-Event Training"
              description={
                <>
                  <h4>Returning Officer Onboarding Program e-Modules</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>1) <a href="https://rise.articulate.com/share/UxDBwuDAtgbvMECqjdAngIaKevG5ZiuL"> Respectful Workplace</a></li>

                    <li>2) <a href="https://rise.articulate.com/share/gcGZt-vLb9Ik-5H2IWtn9L6YE39HsRyT">Occupational Health and Safety</a></li>

                    <li>3) <a href="https://rise.articulate.com/share/GMZVf4OnczTLNA9pn1NutZ9wWWpZlwS-">Introduction to Business Continuity</a></li>

                    <li>4) <a href="https://rise.articulate.com/share/YlS50HFQQVBDKO3qFyEe57JC-jLYSRg_">Organizational Overview</a></li>

                    <li>5) <a href="https://rise.articulate.com/share/XAadIEeSg1YqzrjqSLNlkD_zdJEgqGDE">Role of the Returning Officer</a></li>

                    <li>6) <a href="https://rise.articulate.com/share/svlsrTaq5CJ3dfZzJJa6qUqJ_T16RA1U"> The Election Officer Liaison Role</a></li>

                    <li>7) <a href="https://rise.articulate.com/share/37pryjaELnX2HCwnj4FtteSAk9kv1a5M"> Introduction to Returning Office Financial Administration</a></li>

                    <li>8) <a href="https://rise.articulate.com/share/iWKFqmeVhi4d2hrfd81j4WYeH-8M20Ns"> Introduction to the Election Management System</a></li>

                    <li>9) <a href="https://rise.articulate.com/share/7uV1VFshqiKQv98eqpCse7aHuTRnx_pU"> Introduction to List of Electors, Enumeration, and Revision</a></li>

                    <li>10) <a href="https://rise.articulate.com/share/PVFgvy_QwUw5Pq83YSlH4cwWOHAN_Udz">Introduction to Electoral Mapping and GIS</a></li>

                    <li>11) <a href="https://rise.articulate.com/share/WkShjyLPnK3NQrsGleMYOPlsZT-RcdpE">Introduction to the Election Period </a></li>

                    <li>12) <a href="https://rise.articulate.com/share/Qq96WnpvfrvIR2ReLFW3amxEo8QOh6q_">Introduction to Early Voting</a></li>

                    <li>13) <a href="https://rise.articulate.com/share/VaNsar3I4cIYmS9fXch4ivhKBSb3Wtpg">Introduction to the Write-in Ballot Poll</a></li>

                    <li>14) <a href="https://rise.articulate.com/share/P8zecMSDGRX0Q6aVpJy7-ff82IsH1fOU">Introduction to Election Day </a></li>

                    <li>15) <a href="https://rise.articulate.com/share/kJU9zicD_k5nTU0q53qIQE_h4BIywepr#/">Introduction to the Voting Location Inspection Assignment </a></li>
                  </ul>
                  <br />

                  <h4>Pre-Event Program e-Modules</h4>
                  <br />

                  <ul style={{ paddingLeft: "40px" }}>
                    <li>15) <a href="https://rise.articulate.com/share/tIo-uanMiCtiosn3ZYSMpZ27meWdqHMP">Election Call – Opening the Returning Office</a></li>

                    <li>16) <a href="https://rise.articulate.com/share/dzTI_FDo7gknHFSLJVO2GnRe07JK8wZ_">Escalation and Support Model</a></li>

                    <li>17) <a href="https://rise.articulate.com/share/DpYoe3zmzQWRDeXLUk0MsVGQ92ta-QPI">Deployment of Election Materials</a></li>

                    <li>18) <a href="https://rise.articulate.com/share/wy-2nOJ_74TEilSdlOBpH2t0QB0SancA">Candidate Registrations and Nominations</a></li>

                    <li>19) <a href="https://rise.articulate.com/share/jyd8ln06sMKjsZ4bUIuQWEyWtKJTnwsK">Ballot Production and Distribution</a></li>

                    <li>20) <a href="https://rise.articulate.com/share/6qQM6Na1I74uXVk5nHpJDIMpPu1cOkge"> Managing Revision Activities </a></li>

                    <li>21) <a href="https://360.articulate.com/review/content/891f3749-eddc-4a53-9197-d41a82845e44/review"> Managing the Write-in Ballot Poll </a></li>

                    <li>22) <a href="https://rise.articulate.com/share/ra533UIt65RyLl-VHg1-RquWGcSB8qT8"> Location Confirmations and VIC Production </a></li>

                    <li>23) <a href="https://rise.articulate.com/share/hgQB06K1Hs6PAKBTd5YknNQD5_KLKWEg">Entering Timesheets and Expenses</a></li>

                    <li>24) <a href=" https://rise.articulate.com/share/5k2wTNbqjsuQXn2yVWtLH4EileUlkk6n"> Approving, Processing and Submitting Payroll to ENS</a></li>

                    <li>25) <a href="https://rise.articulate.com/share/y0ypbOVcOLmD7fNl9A6VSlB0g4N0ECCu"> Recruiting, Appointing and Training Election Workers </a></li>

                    <li>26) <a href="https://rise.articulate.com/share/_Vfazq43yO0ptDSe24CIQ1KffXhjlPMy"> Election Day</a></li>

                    <li>27) Processing Voting Location Payments (combined with item 29)</li>

                    <li>28) Processing Election Day Payroll (combined with items 23, 24, and 26) </li>

                    <li>29) <a href="https://rise.articulate.com/share/dblgeyLzKkE5EP1U7-spF-icPakuGlBJ"> Other Post Event Activities and Closing the Office</a></li>

                    <li>30) <a href="https://rise.articulate.com/share/2uHtiB0hTVKSS_8Zvn6U1wxd3gIitwql#/"> Early Voting</a></li>

                    <li>31) <a href="/files/e_module/COVID-19%20Precautions%20and%20Protocols%20for%20Returning%20Offices%20-%20Storyline%20output/story.html"> COVID-19 precautions and protocols for returning office staff</a></li>
                    <li>32) <a href=" /files/e_module/COVID%2019%20Precautions%20and%20Protocols%20for%20Election%20Workers%20-%20Storyline%20output/story.html"> COVID-19 precautions and protocols for election workers</a></li>
                    <li>33) <a href=" https://rise.articulate.com/share/JSmGSQUtVALKlOa3wkh-WK7wkYDBtbP8#/"> Introduction to the Returning Office Telephone System</a></li>

                  </ul>

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EModuleInformation;
